import { Outlet } from "react-router-dom";
import { env } from "@/lib/env";

export default function AuthLayout() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col justify-between p-8">
        <div className="flex items-center gap-2 font-semibold">
          <div className="flex size-8 items-center justify-center rounded-lg bg-gradient-to-br from-indigo-500 to-pink-500 text-white">
            {env.platformName.charAt(0)}
          </div>
          {env.platformName}
        </div>
        <div className="flex flex-1 items-center justify-center">
          <Outlet />
        </div>
        <p className="text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} {env.platformName}. All rights reserved.
        </p>
      </div>
      <div className="relative hidden overflow-hidden lg:block">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/15 via-fuchsia-500/10 to-pink-500/15" />
        <div className="absolute inset-0 [background-image:radial-gradient(circle_at_1px_1px,oklch(0.5_0_0_/_0.18)_1px,transparent_0)] [background-size:24px_24px]" />
        <div className="relative flex h-full flex-col justify-end p-12">
          <h2 className="max-w-md text-3xl font-semibold tracking-tight">
            Build, deploy and scale AI voice agents.
          </h2>
          <p className="mt-3 max-w-md text-sm text-muted-foreground">
            Multi-tenant platform for conversational AI &mdash; agents, flows,
            knowledge bases and analytics in one place.
          </p>
        </div>
      </div>
    </div>
  );
}
